'use client'

import { openSupportChat } from '@/legacy-src/components/support/utilities'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { HeaderSupportButton } from '@/src/domains/header/components/Header/HeaderSupport/HeaderSupportButton'

export const HeaderSupportChatButton = () => {
  const { t } = getTranslate()

  return (
    <HeaderSupportButton icon="talk" onClick={openSupportChat}>
      {t('component.navigation.helpChat')}
    </HeaderSupportButton>
  )
}
